import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { TimerStatus } from '../../../../features/calendar/calendar-types';
import { TimeBlockHttpTransformationService } from '../../../../features/calendar/components/time-block/http/time-block-http-transformation.service';
import {
  TimeBlockContentType,
  TimeBlockIntervalFilter,
} from '../../../../features/calendar/components/time-block/types/time-block-types';
import { DateTimeHelper } from '../../../../features/calendar/util/date-time-helper';
import { HttpOperation } from '../../../enums/http-operation';
import { EndpointService } from '../../../services/endpoints/endpoint.service';
import { HttpErrorService } from '../../../services/http-error.service';
import * as fromUserActions from '../../users/users.actions';
import * as fromTimerActions from './timer.actions';

@Injectable()
export class TimerEffects {
  postTimer$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(fromTimerActions.postTimer),
      map((action) => action.payload),
      switchMap((payload) => {
        const endpoint = this.endpointService.getTimerSlug(HttpOperation.Get);
        // Keep the seconds after clicking "Start". Otherwise, the clock will not start at 00:00.
        const time =
          payload.status === TimerStatus.Start
            ? new Date()
            : DateTimeHelper.setSecondsAndMillisToZero(new Date());
        const timeStr = DateTimeHelper.dateToISO8601String(time);

        return this.http
          .post<{
            timeblock: any[];
          }>(endpoint, { status: payload.status, time: timeStr, task_id: payload.taskId })
          .pipe(
            map((response) => {
              const timeBlockItem = this.timeBlockHttpTransformationService.toTimeBlockItems(
                response.timeblock,
                TimeBlockContentType.Project,
                HttpOperation.Post,
                TimeBlockIntervalFilter.All,
              )[0];

              return fromTimerActions.timerPosted({
                payload: {
                  status: payload.status,
                  generatedTimeBlock: timeBlockItem,
                },
              });
            }),
            catchError((error) => {
              return this.httpErrorService.handleError(
                'Timer',
                fromTimerActions.postTimer,
                fromUserActions,
                error,
              );
            }),
          );
      }),
    );
  });

  constructor(
    private readonly actions$: Actions,
    private readonly http: HttpClient,
    private readonly endpointService: EndpointService,
    private readonly httpErrorService: HttpErrorService,
    private readonly timeBlockHttpTransformationService: TimeBlockHttpTransformationService,
  ) {}
}
